import React from "react";
import brands from "../../demo/brandsHome.json"; 
import "./BrandGrid.scss"; 
import { Link, createSearchParams } from 'react-router-dom';
import { HomeBrandBanner } from "../../types/HomeBrandBanner";
import { mediaUrl } from "../../helper/Api";

interface BrandGridProps {
  banners : HomeBrandBanner[]
}
export default function BrandGrid({banners}:BrandGridProps){
  return (
    <div className="brand-grid">
      {banners?.map((banner) => (
        <Link
          key={banner?.id}
          to={{
            pathname: '/products',
            search: createSearchParams({
              b: banner?.id.toString()
            }).toString()
          }}
          className="brand-card"
        >
          <img src={mediaUrl(banner?.image)} alt={banner?.title} className="brand-image" />
          <h3 className="brand-title">{banner?.title}</h3>
        </Link>
      ))}
    </div>
  );
};
